import { NavigationItem, SidebarNavigation } from '../SidebarNavigation';

interface Props {
  navigationItems: NavigationItem[];
  activePath: string;
  storageKey: string;
}

export const SidebarLayout = ({ children, navigationItems, activePath, storageKey }: React.WithChildren<Props>) => {
  return (
    <div className="mx-auto grid grid-cols-1 items-start gap-10 pb-16 lg:grid-flow-col-dense lg:grid-cols-[auto_minmax(632px,1fr)]">
      <SidebarNavigation items={navigationItems} activePath={activePath} storageKey={storageKey} />
      <div>{children}</div>
    </div>
  );
};
